import { push } from 'connected-react-router'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { RootState } from '../../app/store'
import { pages } from '../../constants/pages'
import NsExercises from './components/NsExercises'
import { next, answer as submitAnswer, requestQuit } from './nsSlice'

const NsExercisesConnect = () => {
  const dispatch = useAppDispatch()
  const { status, exercises, userAnswers, startTime, endTime } = useAppSelector((state: RootState) => state.numberSymbol)

  const handleNext = (repeat?: boolean) => {
    dispatch(next(repeat))
    if (status === 'completed' && !repeat) {
      dispatch(push(pages.home.route))
    }
  }

  const handleSubmitAnswer = (answer: string[]) => {
    dispatch(submitAnswer(answer))
  }

  const handleQuit = (route: string) => {
    dispatch(requestQuit(route))
  }

  return (
    <NsExercises 
      status={status}
      submitAnswerSet={handleSubmitAnswer}
      next={handleNext} 
      exercises={exercises} 
      userAnswers={userAnswers}   
      startTime={startTime}
      endTime={endTime}
      backTo={handleQuit}
    />
  )
}

export default NsExercisesConnect